import { render, staticRenderFns } from "./CarouselPreview.vue?vue&type=template&id=5d1eaaa8&scoped=true&"
import script from "./CarouselPreview.vue?vue&type=script&lang=js&"
export * from "./CarouselPreview.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPreview.vue?vue&type=style&index=0&id=5d1eaaa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1eaaa8",
  null
  
)

export default component.exports